(function () {
    'use strict';

    if (window.reviewImagesInitialized) {
        return;
    }

    window.reviewImagesInitialized = true;

    function renderUpload(input) {
        var upload = input.closest('.reviewUpload');
        var grid = upload.querySelector('.reviewUpload__grid');
        var files = Array.prototype.slice.call(input.files || []);

        grid.innerHTML = '';
        upload.classList.toggle('reviewUpload--has-files', files.length > 0);

        files.forEach(function (file, index) {
            if (file.type.indexOf('image/') !== 0) {
                return;
            }

            var reader = new FileReader();

            reader.onload = function (event) {
                var item = document.createElement('div');
                var image = document.createElement('img');
                var remove = document.createElement('button');

                item.className = 'reviewUpload__item';
                image.className = 'reviewUpload__thumb';
                image.src = event.target.result;
                image.alt = file.name;
                image.title = file.name;
                image.width = 96;
                image.height = 96;
                image.decoding = 'async';
                remove.type = 'button';
                remove.className = 'reviewUpload__remove';
                remove.dataset.reviewPhotoIndex = index;
                remove.innerHTML = '&times;';
                item.appendChild(image);
                item.appendChild(remove);
                grid.appendChild(item);
            };

            reader.readAsDataURL(file);
        });
    }

    function removeUpload(input, file_index) {
        if (typeof DataTransfer === 'undefined') {
            input.value = '';
        } else {
            var transfer = new DataTransfer();

            Array.prototype.slice.call(input.files).forEach(function (file, index) {
                if (index !== file_index) {
                    transfer.items.add(file);
                }
            });

            input.files = transfer.files;
        }

        renderUpload(input);
    }

    function openImage(image_url, image_alt) {
        var modal = document.querySelector('.reviewImageModal');

        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'modal-review-gallery reviewImageModal';
            modal.innerHTML = '<div class="gallery-content"><div class="close-modal-review-gallery"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></div><div class="content-image-modal"><img alt="" width="800" height="800" decoding="async"></div></div>';
            document.body.appendChild(modal);
        }

        var modal_image = modal.querySelector('img');

        modal_image.src = image_url.replace(/\/(fit-in\/[^/]+\/)?filters:[^/]+\//, '/');
        modal_image.alt = image_alt || '';
        modal_image.title = image_alt || '';
        modal.classList.add('open');
    }

    document.addEventListener('click', function (event) {
        var input = document.querySelector('.reviews-page-container #input_photos');
        var remove = event.target.closest('[data-review-photo-index]');
        var image = event.target.closest('[data-review-image]');

        if (input && event.target.closest('#button-review-photos')) {
            input.click();
        } else if (input && event.target.closest('#button-review-photos-remove')) {
            input.value = '';
            renderUpload(input);
        } else if (input && remove) {
            removeUpload(input, Number(remove.dataset.reviewPhotoIndex));
        } else if (image) {
            openImage(image.src, image.alt);
        } else if (event.target.closest('.reviewImageModal .close-modal-review-gallery') || event.target.classList.contains('reviewImageModal')) {
            document.querySelector('.reviewImageModal').classList.remove('open');
        }
    });

    document.addEventListener('change', function (event) {
        if (event.target.matches('.reviews-page-container #input_photos')) {
            renderUpload(event.target);
        }
    });
}());
